import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  /*
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/game',
    name: 'Game',
    component: () => import('@/views/Game.vue'),
  },
  */
  {
    path: '/lockdown',
    name: 'Lockdown Home',
    component: () => import('@/views/CompetitionHome.vue'),
  },
  {
    path: '/lockdown/game',
    name: 'Lockdown Game',
    component: () => import('@/views/CompetitionGame.vue'),
  },
  /*
  {
    path: '/lockdown/results',
    name: 'Lockdown Game Results',
    component: () => import('@/views/CompetitionResults.vue'),
  },
  */
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
